import React from 'react';
import {
  Content,
  Container,
  EventInformation,
  DataContainer,
  MediaWrapper,
  MediaImageWrapper,
  MediaTextWrapper,
} from 'app/components/matchEvents/MatchEventStyles';
import {COLORS, Typography, Image} from '@fupa/fupa-uikit';
import {LinkOnComponent} from 'app/components/links/link';
import PropTypes from 'prop-types';
import {InsertComment} from '@mui/icons-material';

const TickerNewsUploaded = ({news}) => {
  const newsCat = 'News 🤓📝 ';
  const entity = 'news';
  return (
    <LinkOnComponent to={{pathname: `/news/${news.slug}`, state: {updatedAt: news.updatedAt}}}>
      <Content>
        <Container>
          <EventInformation customBgColor={COLORS.darkGreen}>
            <InsertComment style={{color: COLORS.white, fontSize: 20}} />
          </EventInformation>
          <DataContainer>
            <Typography variant='body1'>{newsCat}</Typography>
            <MediaWrapper>
              <MediaTextWrapper>
                <Typography variant='body2'>{news.title}</Typography>
              </MediaTextWrapper>
              <MediaImageWrapper>
                <Image entity={entity} ratio='1:1' width={64} height={64} src={news.image} />
              </MediaImageWrapper>
            </MediaWrapper>
          </DataContainer>
        </Container>
      </Content>
    </LinkOnComponent>
  );
};

TickerNewsUploaded.propTypes = {
  news: PropTypes.object.isRequired,
};

export default TickerNewsUploaded;
